/**
 * Makes an ajax submit
 */
export default {
  props: {
    /**
     * If set will redirect the user after successful submit
     */
    redirectUrl: {
      type: String
    },
  },
  watch: {
    /**
     * @vuese
     * Handle loading state change on template
     */
    isLoading(val) {
      const method = val ? 'addClass' : 'removeClass'
      this.form.find('.form-submit button')[method]('loading')
      this.form.find('input, select, textarea').prop('disabled', val)
      this.$emit('loading', val)
    }
  },
  methods: {
    submitAction(data) {
      const url = this.getUrl()
      return new Promise((resolve, reject) => {
        $.ajax({
          type: this.method || 'POST',
          dataType: this.ajaxDataType,
          contentType: this.ajaxContentType,
          url,
          data: typeof data === 'string' ? data : JSON.stringify(data),
          beforeSend: this.onBeforeSend,
          success: this.onSuccess.bind(this, resolve),
          error: this.onError.bind(this, reject)
        })
      })
    },
    /**
     * @vuese
     * Get url from form action, if transformSubmit is implemented on specific form it will transform it.
     */
    getUrl() {
      const prefix = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : ''
      let url = this.form.attr('action')
      if (typeof this.transformSubmitUrl === 'function') {
        url = this.transformSubmitUrl(url)
      }
      return prefix + url
    },
    /**
     * @vuese
     * Clear errors before submit
     */
    onBeforeSend() {
      this.clearErrors()
    },
    /**
     * @vuese
     * Handles ajax success and redirect if present, if there is an input with id="redirectUrl", it will use this value as redirect url
     */
    onSuccess(resolve, data) {
      if (this.reloadOnSuccess) {
        window.location.reload()
      } else if (this.redirectUrl || this.form.find('input#redirectUrl')[0]) {
        let redirectUrl = this.redirectUrl || this.form.find('input#redirectUrl').val()
        // Allow redirect url be transformed on a component level
        if (typeof this.transformRedirectUrl === 'function') {
          redirectUrl = this.transformRedirectUrl(redirectUrl, data)
        }
        // To cancel redirect return null from the transformRedirectUrl method
        if (redirectUrl) {
          window.location.href = redirectUrl
        } else {
          return resolve(data)
        }
      } else {
        return resolve(data)
      }
    },
    /**
     * @vuese
     * Handles ajax error
     */
    onError(reject, error) {
      throw reject(error)
    },
  }
}